import type { Need } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import type { LMCRequest as LmcRequest } from './types'

const list: LmcRequest<{ result: Need[]; count: number }> = () =>
  getJSON({ url: '/api/list/needs' })

export const needsRequests = {
  list
}
